import React from 'react';

const Wellness = () => {
    return (
        <div style={{ padding: '40px', fontFamily: 'Arial, sans-serif', backgroundColor: '#f9f9f9', margin: '0 auto', maxWidth: '80%' }}>
            {/* Silver Sneakers Program Section */}
            <section style={{ margin: '20px 0', textAlign: 'center' }}>
                <h2 style={{ color: '#883001', fontSize: '32px', marginBottom: '20px' }}>Silver Sneakers Program</h2>
                <img 
                    src="/images/SilverSneakers.jpg" 
                    alt="Silver Sneakers Program" 
                    style={{ width: '100%', maxWidth: '600px', borderRadius: '10px', marginBottom: '20px' }} 
                />
                <p style={{ fontSize: '18px', lineHeight: '1.6', color: '#333' }}>
                    Fritz Physical Therapy is proud to offer the SilverSneakers® exercise program. Join us for fun, music, and exercises designed to improve strength, flexibility, and balance. 
                    Classes are held Thursdays at 9:45am. Equipment like hand-held weights, resistance bands, and a SilverSneakers ball are provided. 
                    A chair is available for seated exercises or support. Suitable for all fitness levels, this program is free for SilverSneakers members, with a nominal fee for non-members.
                </p>
                <p style={{ fontSize: '18px', lineHeight: '1.6', color: '#333' }}>
                    Contact Fritz Physical Therapy for more details!
                </p>
            </section>

            {/* Personal Training Section */}
            <section style={{ margin: '40px 0', textAlign: 'center' }}>
                <h2 style={{ color: '#883001', fontSize: '32px', marginBottom: '20px' }}>Personal Training</h2>
                <img 
                    src="/images/WeightTraining.jpg" 
                    alt="Weight Training" 
                    style={{ width: '100%', maxWidth: '600px', borderRadius: '10px', marginTop: '20px' }} 
                />
                <p style={{ fontSize: '18px', lineHeight: '1.6', color: '#333' }}>
                    At Fritz Physical Therapy, we specialize in health, wellness, and fitness. Whether you're looking to become a stronger athlete, lose weight, or recover from an injury, 
                    we can create a program that is both safe and effective. Our private, judgment-free environment ensures you can work toward your goals with confidence.
                </p>
                <p style={{ fontSize: '18px', lineHeight: '1.6', color: '#333' }}>
                    Our team includes certified trainers, physical therapists, physical therapist assistants, registered dieticians, and certified strength and conditioning specialists. 
                    We have the expertise to help clients from all walks of life. Whether you're dealing with an old injury, a medical condition, or simply need guidance to improve your health, 
                    Fritz Physical Therapy is here to help you get started.
                </p>
                <p style={{ fontSize: '18px', lineHeight: '1.6', color: '#333' }}>
                    Ready to take the next step? Contact us today to schedule your appointment and start your journey toward better health and wellness.
                </p>
            </section>
        </div>
    );
};

export default Wellness;